import {
    loadGradeListBy,
    insertGrade,
    updateActive,
    updateGrade,
    deleteGrade,
    getGradeListBin,
} from '@/service/grade/grade';
import { uploadImage } from '@/service/upload/upload';
export default {
    data() {
        return {
            status_toggle: 0,
            valid: true,
            isOpen: false,
            imageFile: null,
            imgURL: '',
            gradeName: '',
            gradeID: '',

            descriptionRules: [(v) => !!v || 'Description of the Grade is required'],
            description: 'Description of ENGLSIH WITH PETCH Grade',

            gradeLogo: 'https://cdn.vuetifyjs.com/images/parallax/material2.jpg',

            imageReady: false,
            imageRules: [
                (v) => !!v || "Grade's image is required",
                (v) =>
                    (v && v.size < 20000000) || 'Image size should be less than 20 MB!',
            ],

            filterdialog: false,
            deleteDialog: false,
            loading: true,
            sortType: [
                'เวลา สูง-ต่ำ',
                'เวลา ต่ำ-สูง',
                'ยอดนิยม สูง-ต่ำ',
                'ยอดนิยม ต่ำ-สูง',
            ],
            imageName: '',
            grade: [],
            searchdata: '',
            sortData: '',
            searchGrade: null,
            pageCount: 1,
            limit: 10,
            imgPreview: '',
            selectedGrade: [],
            active: '',
            gradeActive: '',
            params: {},
            deleteItemID: [],
            dialogStatus: false,
            dialogStatusActive: false,
            dialogSuccess: false,
            dialogUsernameDuplicade: false,
            dialogAddFail: false,
            dialogAddSuccess: false,
            dialogEditSuccess: false,

            preparePreview: '',

            actionEdit: '',

            dialogRecycleBin: false,
            dialogRecover: false,
            loadingRecover: false,
            gradeBinItem: [],
            dialogFail: false,
            gradeListBin: [],
            pageCountBin: 0,
            paramsBin: {},

            alert: false,
            imgBool: false,

            // editGrade: null,
        };
    },
    async mounted() {
        // console.log("ohm");
        await this.initialize();
    },
    computed: {
        // pages() {
        //   if (
        //     this.pagination.rowsPerPage == null ||
        //     this.pagination.totalItems == null
        //   )
        //     return 0;

        //   return Math.ceil(
        //     this.pagination.totalItems / this.pagination.rowsPerPage
        //   );
        // },
        fileRules() {
            const rules = [];

            // insert
            if (this.gradeID === '') {
                const rule = (v) =>
                    !!v || this.$vuetify.lang.t('$vuetify.gradeManagement.fileRules');
                rules.push(rule);
            }
            if (this.gradeID === '') {
                const rule = (v) =>
                    (v && v.size < 20000000) ||
                    this.$vuetify.lang.t('$vuetify.gradeManagement.fileRulesSize');
                rules.push(rule);
            }

            // update
            if (this.gradeID !== '') {
                const rule = (v) =>
                    (v ? (v.size < 20000000 ? true : false) : true) ||
                    this.$vuetify.lang.t('$vuetify.gradeManagement.fileRulesSize');
                rules.push(rule);
            }

            // if (this.lectureId !== undefined) {
            //   const rule = this.imageUploadId.length > 0 || "file is required";
            //   rules.push(rule);
            // }
            // console.log(" this.imageUploadId.length", this.imageUploadId.length);

            return rules;
        },

        gradeNameRules() {
            return [
                (v) =>
                    !!v ||
                    this.$vuetify.lang.t('$vuetify.gradeManagement.gradeNameRules'),
                (v) =>
                    (v && v.length <= 50) ||
                    this.$vuetify.lang.t('$vuetify.gradeManagement.gradeNameRulesLimit'),
            ];
        },
        headersBin() {
            return [
                {
                    text: this.$vuetify.lang.t('$vuetify.gradeManagement.photo'),
                    align: 'start',
                    sortable: false,
                    value: 'image',
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.gradeManagement.name'),
                    sortable: false,
                    align: 'start',
                    value: 'title',
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.gradeManagement.recover'),
                    align: 'center',
                    sortable: false,
                    value: 'edit',
                },
            ];
        },
        headers() {
            return [
                {
                    text: this.$vuetify.lang.t('$vuetify.gradeManagement.photo'),
                    align: 'start',
                    sortable: false,
                    value: 'image',
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.gradeManagement.name'),
                    value: 'title',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.gradeManagement.createdDate'),
                    value: 'date',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.gradeManagement.statusHeader'),

                    value: 'active',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.gradeManagement.editGrade'),
                    align: 'center',
                    value: 'actions',
                    sortable: false,
                },
            ];
        },
    },
    watch: {
        searchdata(keyword) {
            this.searchInfo(keyword);
        },
    },
    methods: {
        // async preview() {
        //     console.log('imageFile', this.imageFile);
        //     if (this.imageFile != null) {
        //         if (this.imageFile.size > 20000000) return;
        //         this.imgURL = await this.uploadImg(this.imageFile);
        //         this.imgPreview = this.imgURL;
        //         this.imageReady = true;
        //     } else {
        //         if (this.preparePreview) {
        //             this.imgPreview = this.preparePreview;
        //             this.imageReady = true;
        //         } else {
        //             this.imageReady = false;
        //         }
        //     }
        // },
        async preview(event) {
            let file = event.target.files[0];

            this.imageFile = file;
            this.imgPreview = await URL.createObjectURL(file);
            this.imageName = file.name;
            if (this.imgPreview) {
                this.imageReady = true;
            }
            console.log(this.imgPreview)
        },
        searchInfo(keyword) {
            this.params.search = keyword;

            this.getGradeList();
        },
        onSort() {
            if (this.status_toggle == 1) {
                this.params.active = true;
                this.getGradeList();
            } else if (this.status_toggle == 2) {
                this.params.active = false;
                this.getGradeList();
            } else {
                this.params.active = 'null';
                this.getGradeList();
            }
        },
        async changePage(page) {
            this.params.page = page;
            await this.getGradeList();
        },
        async initialize() {
            this.params = {
                search: this.searchGrade,
                sort: 'created_at',
                sortby: -1,
                page: 1,
                limit: 10,
                active: 'null',
            };
            this.searchdata = '';
            this.status_toggle = 0;
            if (!this.$store.state.permission.viewCategory) {
                this.noPermission();
            } else {
                await this.getGradeList();
            }
        },
        refreshFilter() {
            this.initialize();
        },
        async onUpload() {
            let isValidForm = true;
            let isValidImg = true;

            if (this.gradeName.length > 2 && this.gradeName.length <= 50) {
                console.log('GRADE Name:', this.gradeName);
                isValidForm = true;
            } else {
                isValidForm = false;
                console.log('GRADE NAME ERROR');
            }

            if (
                this.imageFile == '' &&
                this.preparePreview == '' &&
                this.imgPreview == ''
            ) {
                isValidImg = false;
                console.log('img null');
            } else {
                isValidImg = true;
            }

            if (isValidForm == true && isValidImg == true) {
                await this.insert();
                await this.getGradeList();
            }
        },
        async getGradeList() {
            this.loading = true;
            let result = await loadGradeListBy(this.params);
            this.grade = [];
            this.pageCount = result.maxPage;
            result.data.forEach((grade) => {
                this.grade.push({
                    date: grade.created_at,
                    id: grade._id,
                    title: grade.title,
                    image: grade.image,
                    active: grade.active,
                    priority: grade.priority,
                    levelSub: grade.levelSub,
                });
            });
            this.loading = false;
            console.log(this.grade);
        },
        async uploadImg(image) {
            let status = await uploadImage('grade', image);
            return status;
        },
        async insert() {
            if (this.actionEdit == 'edit') {
                console.log('updateGrade');
                let body = {};
                if (this.imageFile == '' || this.imageFile == null) {
                    body = {
                        id: this.gradeID,
                        title: this.gradeName,
                        image: this.preparePreview,
                        active: this.gradeActive,
                        priority: this.priority,
                        levelSub: this.levelSub,
                        categories: [],
                    };
                } else {
                    this.imgBool = true;
                    this.imgURL = await this.uploadImg(this.imageFile);
                    body = {
                        id: this.gradeID,
                        title: this.gradeName,
                        image: this.imgURL,
                        active: this.gradeActive,
                        priority: this.priority,
                        levelSub: this.levelSub,
                        categories: [],
                    };
                }
                let status = await updateGrade(body);
                this.imgBool = false;
                if (status.message == 'grade name duplicate') {
                    this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
                    this.gradeName = '';
                } else if (status.code == 403) {
                    this.dialogAddFail = true; //กรณี error อื่น
                } else {
                    this.dialogEditSuccess = true;
                    this.getGradeList();

                    this.gradeID = '';
                    this.gradeName = '';
                    this.imageFile = null;
                    this.imgPreview = '';
                    this.$refs.form.resetValidation();
                    this.imageReady = false;
                    this.isOpen = false;
                    this.imageName = '';
                }
            } else {
                console.log('insertGrade');
                this.imgBool = true;
                this.imgURL = await this.uploadImg(this.imageFile);
                let statusAdd = await insertGrade({
                    title: this.gradeName,
                    image: this.imgURL,
                });
                this.imgBool = false;
                if (statusAdd.message == 'grade name duplicate') {
                    this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
                    this.gradeName = '';
                } else if (statusAdd.code == 403) {
                    this.dialogAddFail = true; //กรณี error อื่น
                } else {
                    this.dialogAddSuccess = true;
                    this.getGradeList();

                    this.gradeID = '';
                    this.gradeName = '';
                    this.imageFile = null;
                    this.imgPreview = '';
                    this.$refs.form.resetValidation();
                    this.imageReady = false;
                    this.isOpen = false;
                    this.imageName = '';
                }
            }
        },

        noPermission() {
            this.alert = true;
        },

        editItem(item) {
            console.log('this.$refs.form : ', this.$refs.form);
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
                this.gradeID = '';
                this.imageReady = false;
                this.gradeName = '';
                this.imageFile = null;
                this.imgPreview = '';
                this.preparePreview = '';
                this.actionEdit = '';
            }
            if (item) {
                let index = this.grade.indexOf(item);
                // this.editGrade = this.grade[index];
                let editGrade = this.grade[index];
                this.gradeID = editGrade.id;
                this.gradeName = editGrade.title;
                this.imgPreview = editGrade.image;
                this.preparePreview = editGrade.image;
                this.gradeActive = editGrade.active;
                this.priority = editGrade.priority;
                this.levelSub = editGrade.levelSub;

                this.actionEdit = 'edit';
            }
            this.isOpen = true;
        },
        closeDialog() {
            this.gradeID = '';
            this.gradeName = '';
            this.imageFile = null;
            this.imgPreview = '';
            this.imageName = '';
            this.preparePreview = '';
            this.$refs.form.resetValidation();
            this.isOpen = false;
            this.imageReady = false;
        },
        openModalStatus(item) {
            let index = this.grade.indexOf(item);
            this.indexItem = index;
            if (this.grade[index].active == true) {
                this.dialogStatus = true;
                this.updateActiveId = this.grade[index].id;
                this.updateActive = this.grade[index].active;
            } else {
                this.dialogStatusActive = true;
                this.updateActiveId = this.grade[index].id;
                this.updateActive = this.grade[index].active;
            }
        },
        async updateActiveGrade() {
            console.log('user Update Active');
            if (this.updateActive == true) {
                console.log('if true -> false');
                let status = await updateActive({
                    id: this.updateActiveId,
                    active: false,
                });
                this.dialogStatus = false;
                this.dialogSuccess = true;
                this.getGradeList();
                return status;
            } else {
                console.log('else false -> true');
                let status = await updateActive({
                    id: this.updateActiveId,
                    active: true,
                });
                this.dialogStatusActive = false;
                this.dialogSuccess = true;
                this.getGradeList();
                return status;
            }
        },
        cancelStatus() {
            this.dialogStatus = false;
            this.grade[this.indexItem].active = this.updateActive;
        },
        cancelStatusActive() {
            this.dialogStatusActive = false;
            this.grade[this.indexItem].active = this.updateActive;
        },
        deleteItem(item) {
            let index = this.grade.indexOf(item);
            let deleteID = this.grade[index];
            this.gradeActive = deleteID.active;
            this.gradeID = deleteID.id;
            this.deleteDialog = true;
        },

        async confirmDelete() {
            if (this.gradeActive === true) {
                let statusActive = await updateActive({
                    id: this.gradeID,
                    active: false,
                });
                let status = await deleteGrade({
                    idgrade: this.gradeID,
                    istrash: true,
                });
                if (status.code == 403 || statusActive.code == 403) {
                    this.dialogFail = false;
                    this.deleteDialog = false;
                } else {
                    this.deleteDialog = false;
                    this.getGradeList();
                }
            } else {
                let status = await deleteGrade({
                    idgrade: this.gradeID,
                    istrash: true,
                });
                if (status.code == 403) {
                    this.dialogFail = false;
                    this.deleteDialog = false;
                } else {
                    this.deleteDialog = false;
                    this.getGradeList();
                }
            }
        },
        async openRecycleBin() {
            await this.getGradeListIsTrash();
            this.dialogRecycleBin = true;
        },
        async changePageBin(page) {
            this.paramsBin.page = page;
            await this.getGradeListIsTrash();
        },
        closeDialogRecover() {
            this.dialogRecycleBin = false;
        },
        async closeDialogRecycleBin() {
            this.dialogRecycleBin = false;
            await this.getGradeList();
        },
        async getGradeListIsTrash() {
            let result = await getGradeListBin(this.paramsBin);
            this.gradeListBin = [];
            this.pageCountBin = result.maxPage;
            result.data.forEach((grade) => {
                this.gradeListBin.push({
                    id: grade._id,
                    image: grade.image,
                    title: grade.title,
                });
            });
        },
        confirmRecover(item) {
            this.gradeBinItem = item;
            this.dialogRecover = true;
        },
        async recoverGrade() {
            this.loadingRecover = true;
            let status = await deleteGrade({
                idgrade: this.gradeBinItem.id,
                istrash: false,
            });
            if (status.code == 403) {
                this.dialogFail = true;
            } else {
                this.deleteDialog = false;
                await this.getGradeListIsTrash();
            }
            this.loadingRecover = false;
            this.dialogRecover = false;
            if (this.gradeListBin.length == 0) {
                this.dialogRecycleBin = false;
            }
            this.gradeBinItem = null;
            this.page = 1;
            this.pageCount - 1;
            await this.initialize();
        },
    },
};
